// All pumps defined here so data looks consistent everywhere

export const pump_registry = [
    {
        meter_id: 2311,
        meter_name: "Raw Water Transfer Pump",
        orientation: "Horizontal",
    },
    {
        meter_id: 2312,
        meter_name: "Clear Water Distribution Pump",
        orientation: "Horizontal",
    },
    {
        meter_id: 2313,
        meter_name: "Fire Hydrant Booster Pump",
        orientation: "Horizontal",
    },
];